<template>
  <div>
    <div class="top">
      <img class="picimg" src="@/assets/image/物联感知服务.png" />
    </div>
    <div style="display: flex; align-items: center" class="prompt">
      <img class="icon" src="@/assets/images/zhuye.png" />
      <span class="color858"
        >&nbsp;&nbsp;你现在的位置&nbsp;&nbsp;/&nbsp;&nbsp;首页&nbsp;&nbsp;/&nbsp;&nbsp;</span
      >
      <span>物联感知服务</span>
    </div>
    <div class="titleBox">
      <span class="title">IOT PERCEPTION</span>
      <span class="title1">物联感知服务</span>
      <span class="line"></span>
    </div>
    <div class="service-main iot-main">
      <section class="iot-section">
        <h2 class="iot-h2">
          <span class="iot-h2-mark"></span>
          应用介绍
        </h2>
        <p class="iot-p">
          物联感知服务是各类智慧场景建设与运营的核心基础服务，依托物联网、智能传感器、无线通信、边缘计算等前沿技术，打造的实时化智能感知网络，可实现对场景内人员、设备、环境、能耗、安全、空间等核心要素进行全方位的实时状态采集与动态感知。
        </p>
      </section>

      <section class="iot-section">
        <h2 class="iot-h2">
          <span class="iot-h2-mark"></span>
          技术框架
        </h2>
        <div class="iot-fw">
          <div class="iot-fw-top">
            <div class="iot-fw-box iot-fw-box--sense">
              <div class="iot-fw-box-title">感知层</div>
              <div class="iot-fw-tags">
                <span class="iot-chip">温湿度传感器</span>
                <span class="iot-chip">烟感报警器</span>
                <span class="iot-chip">电表/水表采集器</span>
                <span class="iot-chip">噪音传感器</span>
                <span class="iot-chip">门禁设备</span>
                <span class="iot-chip">定位标签</span>
                <span class="iot-chip">气体检测仪</span>
                <span class="iot-chip">振动传感器</span>
                <span class="iot-chip">网关采集终端</span>
              </div>
            </div>
            <div class="iot-fw-box iot-fw-box--net">
              <div class="iot-fw-box-title">网络层</div>
              <div class="iot-fw-tags">
                <span class="iot-chip">Lora</span>
                <span class="iot-chip">NB-IoT（Cat.1）</span>
                <span class="iot-chip">WiFi</span>
                <span class="iot-chip">ZigBee</span>
                <span class="iot-chip">RS485/232</span>
                <span class="iot-chip">4G/5G</span>
              </div>
            </div>
            <div class="iot-fw-box iot-fw-box--plat">
              <div class="iot-fw-box-title">平台层</div>
              <div class="iot-fw-tags">
                <span class="iot-chip">数据汇聚</span>
                <span class="iot-chip">数据清洗</span>
                <span class="iot-chip">数据存储</span>
                <span class="iot-chip">智能分析</span>
                <span class="iot-chip">设备管理</span>
                <span class="iot-chip">平台接口</span>
              </div>
            </div>
          </div>
          <div class="iot-fw-bottom">
            <div class="iot-fw-box iot-fw-box--app">
              <div class="iot-fw-box-title">应用层</div>
              <div class="iot-fw-tags iot-fw-tags--app">
                <span class="iot-chip iot-chip--app">智慧城市</span>
                <span class="iot-chip iot-chip--app">智慧街区</span>
                <span class="iot-chip iot-chip--app">智慧景区</span>
                <span class="iot-chip iot-chip--app">智慧工地</span>
                <span class="iot-chip iot-chip--app">智慧物联</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="iot-section iot-section--cases">
        <h2 class="iot-h2">
          <span class="iot-h2-mark"></span>
          应用案例（节选）
        </h2>

        <div class="iot-case-row2">
          <div class="iot-case-card">
            <div class="iot-case-tag">塔式起重机安全监控</div>
            <div class="iot-case-img-wrap">
              <img
                class="iot-case-img"
                src="@/assets/image/塔式起重.png"
                alt="塔式起重机安全监控"
              />
            </div>
          </div>
          <div class="iot-case-card">
            <div class="iot-case-tag iot-case-tag--tail-right">
              施工升降机安全监控
            </div>
            <div class="iot-case-img-wrap">
              <img
                class="iot-case-img"
                src="@/assets/image/施工升级.png"
                alt="施工升降机安全监控"
              />
            </div>
          </div>
        </div>

        <div class="iot-case-grid">
          <div class="iot-case-card iot-case-card--small">
            <div class="iot-case-tag">实名制道闸管理</div>
            <div class="iot-case-img-wrap">
              <img
                class="iot-case-img"
                src="@/assets/image/建筑工人实名制管理.png"
                alt="实名制道闸管理"
              />
            </div>
          </div>
          <div class="iot-case-card iot-case-card--small">
            <div class="iot-case-tag iot-case-tag--tail-right">视频监控</div>
            <div class="iot-case-img-wrap">
              <img
                class="iot-case-img"
                src="@/assets/image/视频监控.png"
                alt="视频监控"
              />
            </div>
          </div>
          <div class="iot-case-card iot-case-card--small">
            <div class="iot-case-tag">环境监测</div>
            <div class="iot-case-img-wrap">
              <img
                class="iot-case-img"
                src="@/assets/image/环境监测.png"
                alt="环境监测"
              />
            </div>
          </div>
          <div class="iot-case-card iot-case-card--small">
            <div class="iot-case-tag iot-case-tag--tail-right">基坑检测</div>
            <div class="iot-case-img-wrap">
              <img
                class="iot-case-img"
                src="@/assets/image/基坑检测.png"
                alt="基坑检测"
              />
            </div>
          </div>
          <div class="iot-case-card iot-case-card--small">
            <div class="iot-case-tag">水电监控</div>
            <div class="iot-case-img-wrap">
              <img
                class="iot-case-img"
                src="@/assets/image/水电监控.png"
                alt="水电监控"
              />
            </div>
          </div>
          <div class="iot-case-card iot-case-card--small">
            <div class="iot-case-tag iot-case-tag--tail-right">无线WiFi</div>
            <div class="iot-case-img-wrap">
              <img
                class="iot-case-img"
                src="@/assets/image/无线WIFI.png"
                alt="无线WiFi"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
    <Bottom />
    <Right />
  </div>
</template>

<script>
import Bottom from "./bottom.vue";
import Right from "./right.vue";

export default {
  components: {
    Bottom,
    Right,
  },
};
</script>

<style lang="scss" scoped>
$iot-blue: #5b9bd5;
$iot-yellow: #e6c229;
$iot-orange: #f29600;
$iot-box: #2f6fad;
$iot-box-dark: #2563a8;

.iot-main {
  max-width: 960px;
  margin: 0 auto 80px;
  padding: 0 40px;
  line-height: 1.85;
  font-size: 16px;
  color: #333;
}

.iot-section {
  margin-top: 40px;

  &:first-of-type {
    margin-top: 20px;
  }
}

.iot-h2 {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: $iot-blue;
  margin: 0 0 18px;
}

.iot-h2-mark {
  width: 10px;
  height: 10px;
  background: $iot-yellow;
  margin-right: 10px;
  flex-shrink: 0;
}

.iot-p {
  margin: 0;
  text-align: justify;
}

.iot-fw {
  background: rgba(47, 111, 173, 0.08);
  border: 1px solid rgba(47, 111, 173, 0.2);
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
}

.iot-fw-top {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}

.iot-fw-bottom {
  width: 100%;
}

.iot-fw-box {
  flex: 1 1 200px;
  min-width: 0;
  background: linear-gradient(165deg, $iot-box 0%, $iot-box-dark 100%);
  border-radius: 8px;
  padding: 14px 12px;
  color: #fff;
  box-sizing: border-box;
}

.iot-fw-box--sense,
.iot-fw-box--net,
.iot-fw-box--plat {
  flex: 1 1 calc(33.33% - 8px);
  min-width: 200px;
}

.iot-fw-box--app {
  width: 100%;
}

.iot-fw-box-title {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.iot-fw-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.iot-fw-tags--app {
  justify-content: center;
}

.iot-chip {
  display: inline-block;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.4;
}

.iot-chip--app {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
}

.iot-section--cases {
  margin-top: 48px;
}

.iot-case-row2 {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 28px;
}

.iot-case-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 20px;
}

.iot-case-card {
  min-width: 0;
}

.iot-case-card--small .iot-case-img {
  max-height: 260px;
}

.iot-case-row2 .iot-case-card {
  flex: 1 1 calc(50% - 10px);
  min-width: 260px;
}

.iot-case-tag {
  display: inline-block;
  margin-bottom: 12px;
  padding: 8px 22px 8px 22px;
  background: $iot-orange;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.35;
  clip-path: polygon(0 50%, 12px 0, 100% 0, 100% 100%, 12px 100%);
}

.iot-case-tag--tail-right {
  padding: 8px 22px 8px 20px;
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%);
}

.iot-case-img-wrap {
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iot-case-img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 320px;
  object-fit: contain;
}

.iot-case-row2 .iot-case-img {
  max-height: 340px;
}

@media (max-width: 768px) {
  .iot-main {
    padding: 0 20px;
  }

  .iot-fw-top {
    flex-direction: column;
  }

  .iot-fw-box--sense,
  .iot-fw-box--net,
  .iot-fw-box--plat {
    flex: 1 1 100%;
    min-width: 0;
  }

  .iot-case-grid {
    grid-template-columns: 1fr;
  }

  .iot-case-row2 {
    flex-direction: column;
  }
}
</style>
